import { Component, Output, EventEmitter, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { EntityDomainService } from 'src/app/admin/entity-domains/shared/entity-domain.service';
import { EntityDomainDto } from 'src/app/affcode/shared/dto/entity-domain.dto';
import { EntityService } from 'src/app/entity/shared/entity.service';
import { NotificationService } from 'src/app/shared';

@Component({
  selector: 'wl-entity-domain-edit-dialog',
  templateUrl: './entity-domain-edit-dialog.component.html',
  styleUrls: ['./entity-domain-edit-dialog.component.less'],
  standalone: false
})
export class EntityDomainEditDialogComponent {
  @ViewChild('editForm') editForm: NgForm;

  @Output() entityDomainSaved = new EventEmitter<EntityDomainDto>();

  show = false;
  entityDomain: EntityDomainDto;
  isSaving: boolean = false;
  isEditing: boolean;
  loadingEntityDomain: boolean = false;
  domainRoots: SelectItem[];
  entityAffCodes: SelectItem[];

  constructor(
    private _entityDomainService: EntityDomainService,
    private _entityService: EntityService,
    private _notificationService: NotificationService
  ) {
    this._entityService.getEntities().then((entities) => {
      this.entityAffCodes = entities.map<SelectItem>((x) => {
        return { label: x.AffCode, value: x.EntityID };
      });
    });

    this.domainRoots = [
      { label: 'Domain Redirect', value: 2 },
      { label: 'Virtual Root', value: 1 },
    ];
  }

  public open(entityDomainId?: number) {
    this.show = true;
    if (entityDomainId) {
      this.isEditing = true;
      this._entityDomainService.getEntityDomain(entityDomainId).then((entityDomain) => {
        this.entityDomain = entityDomain;
      });
    } else {
      this.isEditing = false;
      this.entityDomain = { DomainTypeID: 1 } as EntityDomainDto;
    }
  }

  save() {
    this.isSaving = true;
    let crudPromise: Promise<number>;
    if (this.isEditing) {
      crudPromise = this._entityDomainService.updateEntityDomain(this.entityDomain);
    } else {
      crudPromise = this._entityDomainService.createEntityDomain(this.entityDomain);
    }

    crudPromise
      .then(() => {
        this.entityDomainSaved.emit(this.entityDomain);
        this._notificationService.translateSuccess('common.saved-successfully');
        this.close();
      })
      .catch((error) => {
        this._notificationService.httpError(error);
      })
      .finally(() => (this.isSaving = false));
  }

  close() {
    this.editForm?.form.markAsPristine();
    this.show = false;
  }
}
